import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, CollectionReference,DocumentReference } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  patientCollection: CollectionReference;
  doctorCollection: CollectionReference;
  recordCollection: CollectionReference;
  public currentUser: User;
  recordsData = [];
  user$: Observable<any>;
  loggedIn : boolean;

  constructor(private afs: AngularFirestore, private afsAuth: AngularFireAuth, private router: Router) {
    this.patientCollection = this.afs.firestore.collection('patients');
    this.doctorCollection = this.afs.firestore.collection('doctors');
    this.recordCollection = this.afs.firestore.collection('records');
    this.user$ = this.afsAuth.authState.pipe(
      switchMap(user => {
        if(user){
          this.loggedIn = true;
          // this.currentUser = {name: user.displayName, email: user.email, imageUrl: user.photoURL, uid: user.uid}
          return this.afs.doc<User>(`users/${user.uid}`).valueChanges();
        }else{
          this.loggedIn = false;
          this.currentUser = null;
          return of(null);
        }
      })
    )
  }

  async createUser(user: User){
    if(!this.afsAuth.fetchSignInMethodsForEmail(user.email)){
      alert("User already exsists")
      return;
    }

    this.afsAuth.createUserWithEmailAndPassword(user.email, user.password).then(() => {
      this.currentUser = user;
      if(user.role == 'doctor'){
        this.doctorCollection.add(user).then((docRef) => {
          this.loggedIn = true;
          this.doctorCollection.doc(docRef.id).update({"uid": docRef.id});
        }).catch((err) => console.log(err))
        return;
      }else{
        this.patientCollection.add(user).then((docRef) => {
          this.loggedIn = true;
          this.patientCollection.doc(docRef.id).update({"uid": docRef.id});
        }).catch((err) => console.log(err));
        return;
      }
    }).catch((err) => {
      if(err.code == 'auth/email-already-in-use'){
        alert("Email alreaady in use")
      }else if(err.code == 'auth/invalid-email'){
        alert("Email is invalid. Please try again")
      }else{
        alert("Something went wrong. Please try again")
      }
    })
  }

  async login(user){
    this.afsAuth.signInWithEmailAndPassword(user.email, user.password).then((res) => {
      this.loggedIn = true;
      if(user.role == 'doctor'){
        this.doctorCollection.where('email', '==', res.user.email).get().then((querySnapshot) => {
          querySnapshot.forEach((docRef) => {
            let userData = docRef.data();
            this.currentUser = {name: userData.name, email: userData.email, address: userData.address, state: userData.state, country: userData.country, uid: userData.uid, role: userData.role, phone: userData.phone, password: userData.password};
          })
        })
      }else{
        this.patientCollection.where('email', '==', res.user.email).get().then((querySnapshot) => {
          console.log("completed")
          querySnapshot.forEach((docRef) => {
            let userData = docRef.data();
            console.log(userData)
            this.currentUser = {name: userData.name, email: userData.email, address: userData.address, state: userData.state, country: userData.country, uid: userData.uid, role: userData.role, phone: userData.phone, password: userData.password};
          })
        })
      }
      
      console.log(res.user.uid)
      console.log("Success")
    })
    .catch((err) => {
      alert("Something went wrong");
    })
  }

  async uploadFile(path: String){
    if(this.currentUser.role == 'doctor'){
      this.doctorCollection.doc(this.currentUser.uid.toString()).update({
        records: firebase.default.firestore.FieldValue.arrayUnion(path)
      })
    }else{
      this.patientCollection.doc(this.currentUser.uid.toString()).update({
        records: firebase.default.firestore.FieldValue.arrayUnion(path)
      })
    }
  }

  async signOut(){
    this.loggedIn = false;
    this.currentUser = null;
    await this.afsAuth.signOut();
    this.router.navigate(['/']);
  }

  // async getDoctorRecords(uid: String){
  //   this.doctorCollection.doc(uid.toString()).get().then((docRef) => {
  //     docRef.data().records.forEach((record) => {
  //       this.recordCollection.where('path', '==', record).get().then((querySnapshot) => {
  //         querySnapshot.forEach((docRefData) => {
  //           console.log(docRefData.data())
  //           this.recordsData.push(docRefData.data);
  //         });
  //       })
  //     })
  //   })
  //   return;
  // }

  async getPatientRecords(uid: String){
    let promise = this.patientCollection.doc(uid.toString()).get().then((docRef) => {
      this.recordsData = [];
      docRef.data().records.forEach((record) => {
        this.recordCollection.where('path', '==', record).get().then((querySnapshot) => {
          querySnapshot.forEach((docRefData) => {
            this.recordsData.push(docRefData.data);
          });
        })
      })
      return this.recordsData;
    });
    return promise;
  }

}
